// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
    suggestionMobileStyle: 'style2'
  }
};

(function () {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);
  
  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};

  InstantSearchResultItemProduct.prototype.afterRender = function () {
    if (this.hasOwnProperty("data") && this.data !== null) {
      var data = this.data;
      var priceHtml = this.compileSuggestionProductPrice().replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion);
      var _this = this;
      ajaxPrice(data);
    }
  };

  function ajaxPrice(productData) {
    var activeCurrency = Shopify.currency.active.toUpperCase();
    try {
      // Use Session Storage
      if (
        typeof sessionStorage !== "undefined" &&
        typeof config[productData.id] !== "undefined" &&
        typeof config[productData.id][activeCurrency] !== "undefined"
      ) {
        console.log("Good");
        var onSale =
          config[productData.id][activeCurrency].compare_at_price_min > config[productData.id][activeCurrency].price_min;
        // Format price
        var price = Utils.formatMoney(config[productData.id][activeCurrency].price_min);
        var compareAtPrice = "";
        if (config[productData.id][activeCurrency].compare_at_price_min) {
          compareAtPrice = Utils.formatMoney(config[productData.id][activeCurrency].compare_at_price_min);
          if (Settings.getSettingValue("search.removePriceDecimal")) {
            price = Utils.removeDecimal(price);
            compareAtPrice = Utils.removeDecimal(compareAtPrice);
          }
        }

        // Build Price
        var result = "";
        if (Settings.getSettingValue("search.showSuggestionProductPrice")) {
          if (onSale && Settings.getSettingValue("search.showSuggestionProductSalePrice")) {
            result =
              '<span class="{{class.searchSuggestion}}-product-sale-price">{{regularPrice}}</span>&nbsp;<s>{{compareAtPrice}}</s>';
          } else {
            result = '<span class="{{class.searchSuggestion}}-product-regular-price">{{regularPrice}}</span>';
          }
        }
        result = result
          .replace(/{{regularPrice}}/g, price)
          .replace(/{{compareAtPrice}}/g, compareAtPrice)
          .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion);

        setTimeout(function (params) {
          // console.log(
          //   "result",
          //   result,
          //   jQ(
          //     '.boost-pfs-search-suggestion-item.boost-pfs-search-suggestion-item-product[data-id="' +
          //       productData.id +
          //       '"] .' +
          //       Class.searchSuggestion +
          //       "-product-price",
          //   ),
          // );
          if (
            jQ(
              '.boost-pfs-search-suggestion-item.boost-pfs-search-suggestion-item-product[data-id="' +
                productData.id +
                '"] .' +
                Class.searchSuggestion +
                "-product-price",
            )
          ) {
            jQ(
              '.boost-pfs-search-suggestion-item.boost-pfs-search-suggestion-item-product[data-id="' +
                productData.id +
                '"] .' +
                Class.searchSuggestion +
                "-product-price",
            ).html(result);
          }
        }, 300);
      } else {
        console.log("Almost Good");
        // Use Ajax
        // Set link for ajax
        let productHandleAjax =
          Shopify.routes.root + "products/" + productData.handle + "?view=boost-pfs-custom-integration";
        let requestReg = formRequest(productHandleAjax);
        requestReg
          .then((res_success) => {
            let parse_res_success = JSON.parse(res_success);
            // Set dataAjax session storage config
            var activeCurrencyData = {};
            activeCurrencyData[activeCurrency] = parse_res_success;
            setConfig(parse_res_success.id, activeCurrencyData);
            // Render Ajax Data
            var onSale = parse_res_success.compare_at_price_min > parse_res_success.price_min;
            // Format price
            var price = Utils.formatMoney(parse_res_success.price_min);
            var compareAtPrice = "";
            if (parse_res_success.compare_at_price_min) {
              compareAtPrice = Utils.formatMoney(parse_res_success.compare_at_price_min);
              if (Settings.getSettingValue("search.removePriceDecimal")) {
                price = Utils.removeDecimal(price);
                compareAtPrice = Utils.removeDecimal(compareAtPrice);
              }
            }

            // Build Price
            var result = "";
            if (Settings.getSettingValue("search.showSuggestionProductPrice")) {
              if (onSale && Settings.getSettingValue("search.showSuggestionProductSalePrice")) {
                result =
                  '<span class="{{class.searchSuggestion}}-product-sale-price">{{regularPrice}}</span>&nbsp;<s>{{compareAtPrice}}</s>';
              } else {
                result = '<span class="{{class.searchSuggestion}}-product-regular-price">{{regularPrice}}</span>';
              }
            }
            result = result
              .replace(/{{regularPrice}}/g, price)
              .replace(/{{compareAtPrice}}/g, compareAtPrice)
              .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion);
            if (
              jQ(
                '.boost-pfs-search-suggestion-item.boost-pfs-search-suggestion-item-product[data-id="' +
                  productData.id +
                  '"] .' +
                  Class.searchSuggestion +
                  "-product-price",
              )
            ) {
              jQ(
                '.boost-pfs-search-suggestion-item.boost-pfs-search-suggestion-item-product[data-id="' +
                  productData.id +
                  '"] .' +
                  Class.searchSuggestion +
                  "-product-price",
              ).html(result);
            }
          })
          .catch((res_error) => {
            console.error(res_error);
          });
      }
    } catch (e) {}
  }
  // Add session storage config
  if (typeof sessionStorage !== "undefined") {
    var CUSTOM_HTML_STORAGE_KEY = "shivasfabricsAjaxData";
    var config = JSON.parse(sessionStorage.getItem(CUSTOM_HTML_STORAGE_KEY)) || {};
    function setConfig(key, value) {
      config[key] = value;
      sessionStorage.setItem(CUSTOM_HTML_STORAGE_KEY, JSON.stringify(config));
    }
  }

  function formRequest(value) {
    return new Promise((resolve, reject) => {
      var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
      xhr.open("GET", value);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.onload = () => resolve(xhr.responseText);
      xhr.onerror = () => reject(xhr.statusText);
      xhr.send();
    });
  }

})();